window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.promotionRepo = function () {
    var urlPromotion = 'api/promotion';
    var urlPromotions = 'api/promotions';

    var list = function () {
        return fetch(urlPromotions, {
            credentials: repos.base.credentials
        })
        .then(casino.repos.base.checkResponse)
        .then(function (response) {
            return response.json();
        })
        .catch(casino.repos.base.handleNetworkException);
    };

    var get = function () {
       
    };

    var remove = function (promocija) {
        return fetch(urlPromotion, {
            method: 'DELETE',
            credentials: repos.base.credentials,
            headers: repos.base.headers(),
            body: JSON.stringify(promocija)
        })
        .then(casino.repos.base.checkResponse)
        .catch(casino.repos.base.handleNetworkException);
    };

    var create = function (promocija) {
        return fetch(urlPromotion, {
            method: 'POST',
            credentials: repos.base.credentials,
            headers: repos.base.headers(),
            body: JSON.stringify(promocija)
        })
        .then(casino.repos.base.checkResponse)
        .catch(casino.repos.base.handleNetworkException);
    };


    return {
        list: list,
        get: get,
        remove: remove,
        create: create
    }

}();